import React from 'react';

const Dashboard = () => {
  // const auth = useSelector((state) => state.auth);
  // console.log(auth);
  return <div className="card">Dashboard</div>;
};

export default Dashboard;
